import RaisioLogo from './assets/icons/raisio-logo.svg'

export const logo = {
  src: RaisioLogo,
  alt: 'Raisio logo'
}

export const competitionName = 'Oulun yliopiston uusi kampus'

export const infoTableHeaders = [
  {
    header: 'Asumiseen osoitettu kerrosala - m2 säilyvä rakennuskanta',
    accessor: 'criteria_1'
  },
  {
    header: 'Asumiseen osoitettu kerrosala - m2 uusi rakennuskanta',
    accessor: 'criteria_2'
  },
  {
    header:
      'Liike- ja palvelutiloille osoitettu kerrosala - m2 säilyvä rakennuskanta',
    accessor: 'criteria_3'
  },
  {
    header:
      'Liike- ja palvelutiloille osoitettu kerrosala - m2 uusi rakennuskanta',
    accessor: 'criteria_4'
  },
  {
    header: 'Toimitilalle osoitettu kerrosala - m2 säilyvä rakennuskanta',
    accessor: 'criteria_5'
  },
  {
    header: 'Toimitilalle osoitettu kerrosala - m2 uusi rakennuskanta',
    accessor: 'criteria_6'
  },
  {
    header:
      'Muihin toimintoihin (esim. pysäköinti) osoitettu kerrosala ja maanalainen kerrosala - m2 säilyvä rakennuskanta',
    accessor: 'criteria_7'
  },
  {
    header:
      'Muihin toimintoihin (esim. pysäköinti) osoitettu kerrosala ja maanalainen kerrosala - m2 uusi rakennuskanta',
    accessor: 'criteria_8'
  },
  {
    header: 'Asumista palvelevien autopaikkojen määrä',
    accessor: 'criteria_9'
  },
  {
    header: 'Asumista palvelevien polkupyöräpaikkojen määrä',
    accessor: 'criteria_10'
  },
  {
    header: 'Liike-, palvelu- ja toimitilaa palvelevien autopaikkojen määrä',
    accessor: 'criteria_11'
  },
  {
    header:
      'Liike-, palvelu- ja toimitilaa palvelevien polkupyöräpaikkojen määrä',
    accessor: 'criteria_12'
  },
  {
    header:
      'Suunnitelman brutto- ja kerrosala - kerrosala m2 säilyvä rakennuskanta',
    accessor: 'criteria_13'
  },
  {
    header:
      'Suunnitelman brutto- ja kerrosala - kerrosala m2 uusi rakennuskanta',
    accessor: 'criteria_14'
  }
]

export const settingsTabs = [
  { id: 'settings-users', label: 'Users', value: 'users' },
  { id: 'settings-submit-setup', label: 'Submit setup', value: 'submit-setup' },
  { id: 'rating-criteria', label: 'Rating criteria', value: 'rating-criteria' },
  { id: 'settings-tab-setup', label: 'Tab setup', value: 'tab-setup' },
  { id: 'settings-theme', label: 'Theme', value: 'theme' }
  // { id: 'downloads', label: 'Downloads', value: 'downloads' }
]

export const adminRoles = ['admin', 'secretary']

export const normalRoles = ['judge', 'specialist']

export const FILTER_PROPOSALS_COOKIE_KEY =
  'jt-raisio-filter-proposals-by-private-tags'
